export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';



// WEBPACK FOOTER //
// ./src/actions/auth/actionTypes.js